import request from '@/utils/request'

export function sendUserInfo(data) {
  return request({
    url: '/User/register',
    method: 'post',
    data
  })
}

export function SendCode(data) {
  return request({
    url: '/User/Send',
    method: 'post',
    data
  })
}

export function login(data) {
  return request({
    url: '/User/login',
    method: 'post',
    data
  })
}

export function phoneLogin(data) {
  return request({
    url: '/User/phonelogin',
    method: 'post',
    data
  })
}


export function getmypolicycollection(data) {
  return request({
    url: '/User/getmypolicycollection',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/User/changepassword',
    method: 'post',
    data
  })
}

export function getmyactivitycollection(data) {
  return request({
    url: '/User/getmyactivitycollection',
    method: 'post',
    data
  })
}

// 添加上传图片接口
export function uploadImage(data) {
  return request({
    url: '/Upload/upload',
    method: 'post',
    data,
  })
}

// 修改头像接口
export function updateAvatar(data) {
  return request({
    url: '/User/changeavaimg',
    method: 'post',
    data
  })
}

// 修改手机号
export function updatePhone(data) {
  return request({
    url: '/User/changephone',
    method: 'post',
    data
  })
}

// 获取报名的活动
export function getmyactivity(data) {
  return request({
    url: '/User/getmysign',
    method: 'post',
    data
  })
}

// 获取底部信息
export function getFooterInfo() {
  return request({
    url: '/Config/get',
    method: 'post',
  })
}

// 获取底部链接
export function getFooterLinks() {
  return request({
    url: '/Config/linkGet',
    method: 'post',
  })
}